import React from 'react';
import ContentContainer from '../../components/ContentContainer';
import { useHistory, useLocation } from 'react-router-dom';
import AuthFormPage from './components/AuthFormPage';

const PostSignupPage = () => {
  const history = useHistory();
  const location = useLocation();
  const { email } = location.state || {};
  if (email === undefined) {
    history.push('/signup');
  }

  return (
    <AuthFormPage title="Clickability Signup">
      <ContentContainer maxWidth='sm' title="Check Your Email To Complete Signup">
        <p>
          We&apos;ve sent an email to <b>{email}</b> with a link to activate your account.
        </p>
        <p>
          Please follow the instructions in the email to set your password and get started.
        </p>
        <p>
          Thanks for signing up!
        </p>
      </ContentContainer>
    </AuthFormPage>
  );
};

export default PostSignupPage;
